import React from 'react'
import { useHistory } from 'react-router-dom'
import ExploreSortBlock from '../components/explore_sort_block'
import ExploreTimelinesPills from '../components/explore_timelines_pills'
import StatusList from '../components/status_list'
import {
  EXPLORE_SORTS,
  EXPLORE_SORT_TOPS,
  EXPLORE_SORT_CREATE_PARAMS,
  BREAKPOINT_EXTRA_SMALL,
} from '../constants'
import ResponsiveClassesComponent from './ui/util/responsive_classes_component'
import ResponsiveComponent from './ui/util/responsive_component'

const ExploreTimeline = ({ noPills }) => {
  const history = useHistory()
  
  const handleStatusClick = (status) => {
    const scrollPosition = window.scrollY
    history.push(`/${status.getIn(['account', 'username'])}/posts/${status.get('id')}`, {
      scrollPosition,
      timelineId: 'explore'
    })
  }

  return (
    <>
      { !noPills &&
        <ResponsiveComponent max={BREAKPOINT_EXTRA_SMALL}>
          <ExploreTimelinesPills />
        </ResponsiveComponent>
      }
      <ResponsiveClassesComponent classNamesXS={[_s.d, _s.pl10, _s.pt10].join(' ')}>
        <ExploreSortBlock timelineId='explore' />
      </ResponsiveClassesComponent>
      <StatusList
        timelineId='explore'
        endpoint="/api/v2/timelines/explore"
        showInjections
        paginationLoggedIn
        maxPages={12}
        showAds
        sorts={EXPLORE_SORTS}
        topSorts={EXPLORE_SORT_TOPS}
        createParams={EXPLORE_SORT_CREATE_PARAMS}
        onStatusClick={handleStatusClick}
      />
    </>
  )
}

export default ExploreTimeline
